/**
 * TODO: Upgrade react-facebook package, because our current v8 doesn't include all typings yet.
 * With the next version, v9, all typings are provided, but there are breaking changes for this component.
 */

// @ts-ignore
import { Login } from 'react-facebook';
import {
  Button,
  Fab,
  CircularProgress,
  useTheme,
  darken,
  Box,
  IconButton,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FacebookIcon } from 'assets/icons';
import displayVariant from '../displayVariant';
import type { DisplayVariant } from '../displayVariant';

type PropsType = {
  variant?: DisplayVariant;
  loading: boolean;
  handleSuccess: (token: string) => void;
};

const FacebookLogin = (props: PropsType) => {
  const { variant, loading, handleSuccess } = props;
  const { t } = useTranslation();
  const theme = useTheme();

  // @ts-ignore
  const onSuccess = (response) => {
    const { accessToken } = response.tokenDetail;
    handleSuccess(accessToken);
  };

  const displayRegularButton = () => (
    <Login scope="email" onCompleted={onSuccess}>
      {/* @ts-ignore */}
      {({ handleClick }) => (
        <Button
          sx={{
            color: 'white',
            backgroundColor: '#1877F2',
            fontSize: 'clamp(14px, 1.1vw, 0.9rem)',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: darken('#1877F2', 0.3),
            },
            '&:disabled': {
              backgroundColor: '#1877F2',
            },
            [theme.breakpoints.down('sm')]: {
              width: theme.spacing(42),
              fontWeight: 500,
            },
          }}
          fullWidth
          disableRipple
          disabled={loading}
          variant="rounded"
          onClick={handleClick}
        >
          {loading ? (
            <CircularProgress color="inherit" size={20} />
          ) : (
            <Box>
              <IconButton
                sx={{ position: 'absolute', top: '1px', left: '0.1rem' }}
              >
                <FacebookIcon size={20.5} />
              </IconButton>
              {t('auth:facebookSignIn')}
            </Box>
          )}
        </Button>
      )}
    </Login>
  );

  const displayCircularButton = () => (
    <Login scope="email" onCompleted={onSuccess}>
      {/* @ts-ignore */}
      {({ handleClick }) => (
        <Fab
          sx={{
            width: 52,
            height: 52,
            color: 'white',
            backgroundColor: '#1877F2',
            '&:hover, &:disabled': {
              backgroundColor: '#1877F2',
            },
          }}
          disabled={loading}
          onClick={handleClick}
        >
          {loading ? (
            <CircularProgress color="inherit" size={20} />
          ) : (
            <FacebookIcon color="blue" size={52} />
          )}
        </Fab>
      )}
    </Login>
  );

  return variant === displayVariant.REGULAR
    ? displayRegularButton()
    : displayCircularButton();
};

FacebookLogin.defaultProps = {
  variant: displayVariant.REGULAR,
};

export default FacebookLogin;
